/**
 * Backend Auth API Service
 * Handles passwordless sign-in through the backend API using Resend custom email templates
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Send passwordless sign-in link via backend API (uses Resend with custom template)
 * @param {string} email - The email address to send the sign-in link to
 * @param {string} redirectUrl - Optional redirect URL after sign-in
 * @returns {Promise<Object>} Response with success status and message
 */
export const sendPasswordlessSignInLinkViaBackend = async (email, redirectUrl = null) => {
  try {
    const response = await fetch(`${API_URL}/auth/send-signin-link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        redirect_url: redirectUrl || `${window.location.origin}/auth/action`,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to send sign-in link');
    }

    const data = await response.json();
    console.log('Sign-in link sent via backend:', data);
    return data;
  } catch (error) {
    console.error('Error sending sign-in link via backend:', error);
    throw error;
  }
};

/**
 * Check if backend auth service is healthy
 * @returns {Promise<Object>} Health status
 */
export const checkAuthServiceHealth = async () => {
  try {
    const response = await fetch(`${API_URL}/auth/health`);
    return await response.json();
  } catch (error) {
    console.error('Error checking auth service health:', error);
    throw error;
  }
};
